import React from 'react'

export function TabNavigation({ tabs, activeTab, onTabChange }) {
  return (
    <div className="data-explorer__header">
      <div className="data-explorer__tabs">
        {tabs.map(tab => (
          <button 
            key={tab.id}
            className={`tab ${activeTab === tab.id ? '-active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  )
}

